import { useEffect } from "react";
import { useSelector } from "react-redux";
import { authUser } from "../../../store/slice/authSlice";
import { useGetOnboardingQuery } from "../../../store/apiSlice/onboardingApiSlice";
import { useSetupGuide } from "../SetupGuideContext";

const storageKey = userId => `orderlink:setupGuideAutoOpened:${userId}`;

export function useSetupGuideAutoOpen() {
  const user = useSelector(authUser);
  const { openSetupGuide, drawerOpen } = useSetupGuide();
  const { data } = useGetOnboardingQuery(undefined, { skip: !user?.company_id });

  useEffect(() => {
    if (!user?.id || !data?.enabled || drawerOpen) {
      return;
    }
    if (data.hidden || !data.progress?.total || data.progress.percent >= 100) {
      return;
    }
    const key = storageKey(user.id);
    if (window.localStorage.getItem(key)) {
      return;
    }
    window.localStorage.setItem(key, "1");
    openSetupGuide();
  }, [data, drawerOpen, openSetupGuide, user?.id]);
}
